"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const validator = require("validator");
const react_redux_1 = require("react-redux");
const react_bootstrap_1 = require("react-bootstrap");
const util_1 = require("util");
const react_router_redux_1 = require("react-router-redux");
const utils_1 = require("../utils");
const AuthenticationActions_1 = require("../authentication/AuthenticationActions");
const constants_1 = require("../constants");
const { V_LOYAL_REACH } = require('../../../config');
const Loader_1 = require("../shared/Loader");
const api_1 = require("../api");
function mapDispatchToProps(dispatch) {
    return {
        login: payload => dispatch(AuthenticationActions_1.login(payload)),
        dispatch
    };
}
function mapStateToProps(state = constants_1.INITIAL_STATE) {
    return {
        loginProgress: state.landingPage.loginProgress,
        loginErrors: state.landingPage.loginErrors
    };
}
class OrganizationLoginComponent extends React.Component {
    constructor(props) {
        super(props);
        this.email = "";
        this.password = "";
        this.login = this.login.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.state = {
            state: constants_1.ProgressState.Loading,
            shouldUpdate: true,
            organization: null
        };
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.loginProgress === constants_1.ProgressState.Success) {
            window.location.replace(constants_1.ROUTES.Application.Dashboard(this.props.params.orgRoutePrefix));
        }
    }
    componentDidMount() {
        document.body.scrollTop = 0;
    }
    scriptsLoaded() {
        api_1.doGet(api_1.API.v2.ORGANIZATION.GET(this.props.params.orgRoutePrefix)).then(response => {
            this.setState({ state: constants_1.ProgressState.Success, organization: response.data.response });
        }).catch(error => {
            api_1.handleError(error);
        });
    }
    login() {
        $('.help-block').empty();
        if (!this.isValid()) {
            return;
        }
        this.setState({ shouldUpdate: true });
        this.props.login({
            email: this.email,
            password: this.password,
            remember: this.remember
        });
    }
    handleKeyPress(target) {
        if (target.charCode !== 13) {
            return;
        }
        if (target.target.name == "email") {
            $("#password").focus();
        } else {
            this.login();
        }
    }
    componentDidUpdate() {
        if (!this.props.loginErrors) {
            return;
        }
        this.props.loginErrors.map(err => {
            if (err.reason == "LOGIN_FAILED") {
                this.setState({
                    password: {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: this.state.password.errorMessage
                    },
                    email: {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: this.state.email.errorMessage
                    },
                    errorBlock: {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: "Email or password was incorrect"
                    },
                    shouldUpdate: false,
                    state: constants_1.ProgressState.Failed,
                    button: "danger"
                });
            } else if (err.reason == "USER_NOT_ACTIVATED") {
                this.setState({
                    password: {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: this.state.password.errorMessage
                    },
                    email: {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: this.state.email.errorMessage
                    },
                    errorBlock: {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: "User not activated"
                    },
                    shouldUpdate: false,
                    state: constants_1.ProgressState.Failed,
                    button: "danger"
                });
            }
        });
    }
    shouldComponentUpdate() {
        return this.state.shouldUpdate;
    }
    render() {
        let buttonStyle = "primary";
        let loginFailed;
        if (this.state.state == constants_1.ProgressState.Failed) {
            loginFailed = utils_1.FormUtils.showErrorBlock(this.state.errorBlock);
            if (this.state.button == "danger") {
                buttonStyle = "danger";
            }
        }
        return React.createElement("div", null, React.createElement("link", { href: `/css/main.css?V_LOYAL_REACH=${V_LOYAL_REACH}`, rel: "stylesheet" }), React.createElement(Loader_1.default, { libraries: [], onLoad: () => this.scriptsLoaded() }), React.createElement(react_bootstrap_1.Row, { className: "pl-24 color-blue pt-12" }, React.createElement(react_bootstrap_1.Col, null, this.state.organization && this.state.organization.settings && this.state.organization.settings.logoUrl && React.createElement("img", { width: 100, src: this.state.organization.settings.logoUrl, alt: "organization logo" }), this.state.organization && (!this.state.organization.settings || !this.state.organization.settings.logoUrl) && React.createElement("h2", null, this.state.organization && this.state.organization.name))), React.createElement(react_bootstrap_1.Row, { className: "flex-center flex-horizontal-center pt-120" }, React.createElement(react_bootstrap_1.Col, { xs: 12, md: 8 }, React.createElement(react_bootstrap_1.Panel, { className: "login-panel organization-auth-panel" }, React.createElement("div", { className: "panel-body" }, React.createElement("h2", { className: "text-center" }, "Please Sign In"), React.createElement("div", { className: "text-center has-error" }, loginFailed), React.createElement("fieldset", null, React.createElement(react_bootstrap_1.FormGroup, Object.assign({ controlId: "email" }, utils_1.FormUtils.formGroupAttributes(this.state.email)), React.createElement(react_bootstrap_1.FormControl, { placeholder: "E-mail", name: "email", type: "email", onKeyPress: this.handleKeyPress, onChange: event => utils_1.FormUtils.dataChanged(event, this) }), utils_1.FormUtils.showErrorBlock(this.state.email)), React.createElement(react_bootstrap_1.FormGroup, Object.assign({ controlId: "password" }, utils_1.FormUtils.formGroupAttributes(this.state.password)), React.createElement(react_bootstrap_1.FormControl, { placeholder: "Password", name: "password", type: "password", onKeyPress: this.handleKeyPress, onChange: event => utils_1.FormUtils.dataChanged(event, this) }), utils_1.FormUtils.showErrorBlock(this.state.password)), React.createElement(react_bootstrap_1.Checkbox, { onChange: event => utils_1.FormUtils.dataChanged(event, this), name: "remember" }, "Remember Me"), React.createElement("br", null), React.createElement(react_bootstrap_1.Button, { className: "modal-button organization-login-button", title: "Sign in", bsStyle: buttonStyle, onClick: this.login }, "Sign in")), React.createElement("br", null), React.createElement("br", null), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 6 }, React.createElement("a", { href: "javascript:void(0)", onClick: () => this.props.dispatch(react_router_redux_1.push(constants_1.ROUTES.Landing.ForgotPassword(this.props.params.orgRoutePrefix))) }, "Forgot password?")), React.createElement(react_bootstrap_1.Col, { xs: 6, className: "text-right" }, React.createElement("a", { href: "javascript:void(0)", onClick: () => this.props.dispatch(react_router_redux_1.push(constants_1.ROUTES.Landing.Register(this.props.params.orgRoutePrefix))) }, "Sign up now!"))))))));
    }
    isValid() {
        let valid = true;
        if (util_1.isNullOrUndefined(this.email) || validator.isEmpty(this.email)) {
            this.setState({
                email: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Email can't be blank."
                },
                button: "danger"
            });
        } else if (!validator.isEmail(this.email)) {
            this.setState({
                email: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Not valid email format."
                },
                button: "danger"
            });
        } else {
            this.setState({
                email: {
                    state: constants_1.ProgressState.Success
                }
            });
        }
        if (util_1.isNullOrUndefined(this.password) || validator.isEmpty(this.password)) {
            this.setState({
                password: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Password can't be blank."
                }, button: "danger"
            });
        } else {
            this.setState({
                password: {
                    state: constants_1.ProgressState.Success
                }
            });
        }
        return valid;
    }
}
const OrganizationLogin = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(OrganizationLoginComponent);
exports.default = OrganizationLogin;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/OrganizationLogin.tsx
// module id = 1344
// module chunks = 0 1